import api from './axios'

export const getStaff = async (params = {}) => {
  const response = await api.get('/staff', { params })
  return response.data
}

export const getStaffMember = async (id) => {
  const response = await api.get(`/staff/${id}`)
  return response.data
}

export const getStaffByDepartment = async (department) => {
  const response = await api.get(`/staff/department/${department}`)
  return response.data
}

export const getStaffStats = async () => {
  const response = await api.get('/staff/admin/stats')
  return response.data
}

export const createStaffMember = async (formData) => {
  const response = await api.post('/staff', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}

export const updateStaffMember = async (id, formData) => {
  const response = await api.patch(`/staff/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return response.data
}

export const deleteStaffMember = async (id) => {
  const response = await api.delete(`/staff/${id}`)
  return response.data
}

export const bulkDeleteStaff = async (ids) => {
  const response = await api.post('/staff/bulk-delete', { ids })
  return response.data
}

export default {
  getStaff,
  getStaffMember,
  getStaffByDepartment,
  getStaffStats,
  createStaffMember,
  updateStaffMember,
  deleteStaffMember,
  bulkDeleteStaff,
}
